module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Building Reconaissance Form")]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('tabs', {
    attrs: {
      "nav-style": "tabs"
    },
    model: {
      value: (_vm.activeTabIndex),
      callback: function($$v) {
        _vm.activeTabIndex = $$v
      },
      expression: "activeTabIndex"
    }
  }, [_c('tab', {
    attrs: {
      "header": "Reconnaissance Form"
    }
  }, [_c('projectHeader', {
    ref: "projectHeader",
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('surveyHeader', {
    ref: "surveyHeader",
    attrs: {
      "survey": _vm.surveyDto
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('form', {
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "reconForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('h4', [_vm._v("Identification")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "clear"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('reconForm.temporaryFieldId')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Temporary Field ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.fieldNumber),
      expression: "reconFormDto.fieldNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "temporaryFieldId"
    },
    domProps: {
      "value": (_vm.reconFormDto.fieldNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "fieldNumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('reconForm.historicName')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Historic Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.historicName),
      expression: "reconFormDto.historicName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "historicName"
    },
    domProps: {
      "value": (_vm.reconFormDto.historicName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "historicName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Other Common Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.otherName),
      expression: "reconFormDto.otherName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.otherName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "otherName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Ownership Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.landownerTypeId),
      expression: "reconFormDto.landownerTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reconFormDto, "landownerTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.landownerTypeList), function(t) {
    return _c('option', {
      domProps: {
        "value": t.id
      }
    }, [_vm._v("\r\n                                " + _vm._s(t.description) + "\r\n                            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Current Function Type")]), _vm._v(" "), _vm._l((_vm.functionList), function(t) {
    return _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCurrentFunction),
        expression: "selectedCurrentFunction"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'currentFunction' + t.description
      },
      domProps: {
        "value": t.buildingFunctionId,
        "checked": Array.isArray(_vm.selectedCurrentFunction) ? _vm._i(_vm.selectedCurrentFunction, t.buildingFunctionId) > -1 : (_vm.selectedCurrentFunction)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCurrentFunction,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t.buildingFunctionId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCurrentFunction = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCurrentFunction = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCurrentFunction = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'currentFunction' + t.description
      }
    }, [_vm._v(_vm._s(t.description))])])])
  })], 2)]), _vm._v(" "), _c('h4', [_vm._v("Location")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "clear"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Street Address")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.errors.has('reconForm.streetAddress')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.streetAddress),
      expression: "reconFormDto.streetAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "streetAddress"
    },
    domProps: {
      "value": (_vm.reconFormDto.streetAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "streetAddress", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Parcel ID")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.parcelId),
      expression: "reconFormDto.parcelId"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.parcelId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "parcelId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("City/Town")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.errors.has('reconForm.streetAddress')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.city),
      expression: "reconFormDto.city"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "city"
    },
    domProps: {
      "value": (_vm.reconFormDto.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "city", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Vicinity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.isVicinity),
      expression: "reconFormDto.isVicinity"
    }],
    attrs: {
      "type": "checkbox",
      "id": "vicinityCB"
    },
    domProps: {
      "checked": Array.isArray(_vm.reconFormDto.isVicinity) ? _vm._i(_vm.reconFormDto.isVicinity, null) > -1 : (_vm.reconFormDto.isVicinity)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reconFormDto.isVicinity,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reconFormDto.isVicinity = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reconFormDto.isVicinity = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.reconFormDto, "isVicinity", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "vicinityCB"
    }
  }, [_vm._v(" ")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("County")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    class: {
      'has-error': _vm.errors.has('reconForm.county')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.countyId),
      expression: "reconFormDto.countyId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "county"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reconFormDto, "countyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.countyList), function(county) {
    return _c('option', {
      domProps: {
        "value": county.countyId
      }
    }, [_vm._v("\r\n                                " + _vm._s(county.description) + "\r\n                            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Subdivision/Plat")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.subdivision),
      expression: "reconFormDto.subdivision"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.subdivision)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "subdivision", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Block(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.block),
      expression: "reconFormDto.block"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.block)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "block", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label text-label"
  }, [_vm._v("Lot(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.lot),
      expression: "reconFormDto.lot"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.lot)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "lot", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('h4', [_vm._v("Construction and Alteration")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "clear"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Estimated")]), _vm._v(" "), _c('th', [_vm._v("Comment")]), _vm._v(" "), _c('th', [_vm._v("Source")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reconFormDto.constructionDateList), function(date) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(date.constructionDateTypeDescription))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.date))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.isEstimate ? 'Yes' : 'No'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(date.source))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1 col-md-offset-10"
  }, [_c('button', {
    staticClass: "form-contol btn",
    on: {
      "click": function($event) {
        _vm.$refs['constructionDateModal'].open()
      }
    }
  }, [_vm._v("Add Construction Dates")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Architect(s)/Builder(s)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.architect),
      expression: "reconFormDto.architect"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.architect)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "architect", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Historic Function Type")]), _vm._v(" "), _vm._l((_vm.functionList), function(t) {
    return _c('div', {
      staticClass: "col-md-1"
    }, [_c('div', {
      staticClass: "checkbox checkbox-inline"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedHistoricFunction),
        expression: "selectedHistoricFunction"
      }],
      attrs: {
        "type": "checkbox",
        "id": 'historicFunction' + t.description
      },
      domProps: {
        "value": t.buildingFunctionId,
        "checked": Array.isArray(_vm.selectedHistoricFunction) ? _vm._i(_vm.selectedHistoricFunction, t.buildingFunctionId) > -1 : (_vm.selectedHistoricFunction)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedHistoricFunction,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = t.buildingFunctionId,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedHistoricFunction = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedHistoricFunction = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedHistoricFunction = $$c
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": 'historicFunction' + t.description
      }
    }, [_vm._v(_vm._s(t.description))])])])
  })], 2)]), _vm._v(" "), _c('h4', [_vm._v("Architectural Description")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "clear"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Style")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.buildingStyleId),
      expression: "reconFormDto.buildingStyleId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reconFormDto, "buildingStyleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.buildingStyleList), function(style) {
    return _c('option', {
      domProps: {
        "value": style.buildingStyleId
      }
    }, [_vm._v("\r\n                                " + _vm._s(style.description) + "\r\n                            ")])
  })], 2)]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Type/Form")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.buildingTypeId),
      expression: "reconFormDto.buildingTypeId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reconFormDto, "buildingTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v(" Select a value")]), _vm._v(" "), _vm._l((_vm.buildingTypeList), function(val) {
    return _c('option', {
      attrs: {
        "disabled": val.isHeader
      },
      domProps: {
        "value": val.buildingTypeId
      }
    }, [_vm._v("\r\n                                " + _vm._s(val.description) + "\r\n                            ")])
  })], 2)]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Stories")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.storyId),
      expression: "reconFormDto.storyId"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reconFormDto, "storyId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _vm._l((_vm.storyList), function(story) {
    return _c('option', {
      domProps: {
        "value": story.storyId
      }
    }, [_vm._v("\r\n                                " + _vm._s(story.description) + "\r\n                            ")])
  })], 2)]), _vm._v(" "), _c('label', {
    staticClass: "col-md-1 control-label"
  }, [_vm._v("Replaced")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.replacedDoors),
      expression: "reconFormDto.replacedDoors"
    }],
    attrs: {
      "type": "checkbox",
      "id": "replacedDoorsCB"
    },
    domProps: {
      "checked": Array.isArray(_vm.reconFormDto.replacedDoors) ? _vm._i(_vm.reconFormDto.replacedDoors, null) > -1 : (_vm.reconFormDto.replacedDoors)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reconFormDto.replacedDoors,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reconFormDto.replacedDoors = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reconFormDto.replacedDoors = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.reconFormDto, "replacedDoors", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "replacedDoorsCB"
    }
  }, [_vm._v("Doors")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.replacedWindows),
      expression: "reconFormDto.replacedWindows"
    }],
    attrs: {
      "type": "checkbox",
      "id": "replacedWindowsCB"
    },
    domProps: {
      "checked": Array.isArray(_vm.reconFormDto.replacedWindows) ? _vm._i(_vm.reconFormDto.replacedWindows, null) > -1 : (_vm.reconFormDto.replacedWindows)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reconFormDto.replacedWindows,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reconFormDto.replacedWindows = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reconFormDto.replacedWindows = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.reconFormDto, "replacedWindows", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "replacedWindowsCB"
    }
  }, [_vm._v("Windows")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-10 col-md-offset-2"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Element")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "40%"
    }
  }, [_vm._v("Material")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.reconFormDto.buildingElementList), function(element) {
    return _c('tr', {
      key: element.buildingElementId
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(element.description))])]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.buildingElementTypeId),
        expression: "element.buildingElementTypeId"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(element, "buildingElementTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.elementTypeList.filter(function (x) {
      return x.buildingElementId === element.buildingElementId
    })), function(elementType) {
      return _c('option', {
        domProps: {
          "value": elementType.elementTypeId
        }
      }, [_vm._v("\r\n                                            " + _vm._s(elementType.description) + "\r\n                                        ")])
    })], 2)]), _vm._v(" "), _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (element.buildingElementMaterialId),
        expression: "element.buildingElementMaterialId"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(element, "buildingElementMaterialId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.elementMaterialList.filter(function (x) {
      return x.buildingElementId === element.buildingElementId
    })), function(elementType) {
      return _c('option', {
        domProps: {
          "value": elementType.elementMaterialId
        }
      }, [_vm._v("\r\n                                            " + _vm._s(elementType.description) + "\r\n                                        ")])
    })], 2)])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Notable Features")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.notableFeatures),
      expression: "reconFormDto.notableFeatures"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.notableFeatures)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "notableFeatures", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Outbuildings")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.outbuildings),
      expression: "reconFormDto.outbuildings"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.outbuildings)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "outbuildings", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('h4', [_vm._v("Preservation and Planning")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "clear"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2  control-label text-label"
  }, [_vm._v("Integrity")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.errors.has('reconForm.integrity')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.buildingIntegrityId),
      expression: "reconFormDto.buildingIntegrityId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "integrity"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reconFormDto, "buildingIntegrityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.buildingIntegrityList), function(integrity) {
    return _c('option', {
      domProps: {
        "value": integrity.buildingIntegrityId
      }
    }, [_vm._v("\r\n                                " + _vm._s(integrity.description) + "\r\n                            ")])
  })], 2)]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Condition")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.errors.has('reconForm.condition')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.buildingConditionId),
      expression: "reconFormDto.buildingConditionId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "condition"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reconFormDto, "buildingConditionId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.buildingConditionList), function(condition) {
    return _c('option', {
      domProps: {
        "value": condition.buildingConditionId
      }
    }, [_vm._v("\r\n                                " + _vm._s(condition.description) + "\r\n                            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('reconForm.conditionComments')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.conditionComment),
      expression: "reconFormDto.conditionComment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "conditionComments",
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.conditionComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "conditionComment", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Priority for Intensive Survey")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'has-error': _vm.errors.has('reconForm.priority')
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.surveyPriorityId),
      expression: "reconFormDto.surveyPriorityId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "priority"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.reconFormDto, "surveyPriorityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.priorityList), function(priority) {
    return _c('option', {
      domProps: {
        "value": priority.surveyPriorityId
      }
    }, [_vm._v("\r\n                                " + _vm._s(priority.description) + "\r\n                            ")])
  })], 2)]), _vm._v(" "), _c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Potential Eligibility")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.isPotentialLocal),
      expression: "reconFormDto.isPotentialLocal"
    }],
    attrs: {
      "type": "checkbox",
      "id": "potentialLocalCB"
    },
    domProps: {
      "checked": Array.isArray(_vm.reconFormDto.isPotentialLocal) ? _vm._i(_vm.reconFormDto.isPotentialLocal, null) > -1 : (_vm.reconFormDto.isPotentialLocal)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reconFormDto.isPotentialLocal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reconFormDto.isPotentialLocal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reconFormDto.isPotentialLocal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.reconFormDto, "isPotentialLocal", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "potentialLocalCB"
    }
  }, [_vm._v("Local")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.isPotentialNRHP),
      expression: "reconFormDto.isPotentialNRHP"
    }],
    attrs: {
      "type": "checkbox",
      "id": "potentialNRHPCB"
    },
    domProps: {
      "checked": Array.isArray(_vm.reconFormDto.isPotentialNRHP) ? _vm._i(_vm.reconFormDto.isPotentialNRHP, null) > -1 : (_vm.reconFormDto.isPotentialNRHP)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reconFormDto.isPotentialNRHP,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reconFormDto.isPotentialNRHP = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reconFormDto.isPotentialNRHP = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.reconFormDto, "isPotentialNRHP", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "potentialNRHPCB"
    }
  }, [_vm._v("National Register of Historic Places")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.isPotentialUnknown),
      expression: "reconFormDto.isPotentialUnknown"
    }],
    attrs: {
      "type": "checkbox",
      "id": "potentialUnknownCB"
    },
    domProps: {
      "checked": Array.isArray(_vm.reconFormDto.isPotentialUnknown) ? _vm._i(_vm.reconFormDto.isPotentialUnknown, null) > -1 : (_vm.reconFormDto.isPotentialUnknown)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.reconFormDto.isPotentialUnknown,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.reconFormDto.isPotentialUnknown = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.reconFormDto.isPotentialUnknown = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.reconFormDto, "isPotentialUnknown", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "potentialUnknownCB"
    }
  }, [_vm._v("Unknown")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('reconForm.generalComments')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Comments")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.preservationComment),
      expression: "reconFormDto.preservationComment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "generalComments",
      "type": "text"
    },
    domProps: {
      "value": (_vm.reconFormDto.preservationComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "preservationComment", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('h4', [_vm._v("Site History")]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('reconForm.buildingHistory')
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label text-label"
  }, [_vm._v("Describe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reconFormDto.buildingHistory),
      expression: "reconFormDto.buildingHistory"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "buildingHistory",
      "rows": "6"
    },
    domProps: {
      "value": (_vm.reconFormDto.buildingHistory)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reconFormDto, "buildingHistory", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6 col-md-offset-2"
  }, [_c('validationResultDisplay', {
    attrs: {
      "validationResult": _vm.validationResult
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-1 col-md-offset-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.saveForm
    }
  }, [_vm._v("Save")])])])]), _vm._v(" "), _c('modal', {
    ref: "constructionDateModal"
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v("Construction Dates")]), _vm._v(" "), _c('button', {
    staticClass: "btn pull-right",
    on: {
      "click": function($event) {
        _vm.$refs['constructionDateModal'].close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form form-horizontal",
    attrs: {
      "data-vv-scope": "constructionDates"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionDates.dateType')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Date type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.constructionDateTypeId),
      expression: "constructionDateDto.constructionDateTypeId"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "dateType",
      "data-vv-scope": "constructionDates"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.constructionDateDto, "constructionDateTypeId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("Select a value")]), _vm._v(" "), _vm._l((_vm.constructionDateTypes), function(dateType) {
    return _c('option', {
      domProps: {
        "value": dateType.constructionDateTypeId
      }
    }, [_vm._v("\r\n                                        " + _vm._s(dateType.description) + "\r\n                                    ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionDates.date')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.date),
      expression: "constructionDateDto.date"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "date",
      "type": "text",
      "data-vv-scope": "constructionDates"
    },
    domProps: {
      "value": (_vm.constructionDateDto.date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "date", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Estimated")]), _vm._v(" "), _c('div', {
    staticClass: " col-md-2"
  }, [_c('div', {
    staticClass: "checkbox checkbox-inline",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.isEstimate),
      expression: "constructionDateDto.isEstimate"
    }],
    attrs: {
      "id": "estimateCB",
      "type": "checkbox",
      "data-vv-scope": "constructionDates"
    },
    domProps: {
      "checked": Array.isArray(_vm.constructionDateDto.isEstimate) ? _vm._i(_vm.constructionDateDto.isEstimate, null) > -1 : (_vm.constructionDateDto.isEstimate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.constructionDateDto.isEstimate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.constructionDateDto.isEstimate = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.constructionDateDto.isEstimate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.constructionDateDto, "isEstimate", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "estimateCB"
    }
  }, [_vm._v(" ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionDates.comment')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Comment")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.comment),
      expression: "constructionDateDto.comment"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "comment",
      "data-vv-scope": "constructionDates"
    },
    domProps: {
      "value": (_vm.constructionDateDto.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "comment", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('constructionDates.source')
    }
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.constructionDateDto.source),
      expression: "constructionDateDto.source"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "source",
      "data-vv-scope": "constructionDates"
    },
    domProps: {
      "value": (_vm.constructionDateDto.source)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.constructionDateDto, "source", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary col-md-3",
    attrs: {
      "name": "buttonDone"
    },
    on: {
      "click": function($event) {
        _vm.constructionDatesDone()
      }
    }
  }, [_vm._v("Done")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary col-md-3 pull-right",
    attrs: {
      "name": "buttonMore"
    },
    on: {
      "click": function($event) {
        _vm.constructionDatesMore()
      }
    }
  }, [_vm._v("More")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDebug),
      expression: "isDebug"
    }]
  }, [_c('h3', [_vm._v("DEBUG")]), _vm._v(" "), _c('pre', [_vm._v("\r\n                " + _vm._s(_vm.reconFormDto) + "\r\n            ")])])], 1)], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Documents"
    }
  }, [_c('reconFormDocuments', {
    attrs: {
      "reconForm": _vm.reconFormDto
    }
  })], 1), _vm._v(" "), _c('tab', {
    attrs: {
      "header": "Workflow"
    }
  }, [_c('projectHeader', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('workflow', {
    ref: "workflow",
    attrs: {
      "workflowId": _vm.reconFormWorkflowId,
      "parentId": _vm.reconFormDto.buildingReconFormId
    },
    on: {
      "workflowOnSubmitSuccess": _vm.workflowOnSubmitSuccess
    }
  })], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-29a27d2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BuildingReconForm.vue
// module id = 914
// module chunks = 1